/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { Container, InfoButton, Title } from "./styles";
import { Outlet } from "react-router-dom";
import {
	useGetGiftsFriendShopQuery,
	useGetFriendsFriendShopQuery
} from "redux/apis/friendShop";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { InfoIcon } from "utils/svgIcons";
import { useGoogleAnalyticsContext } from "contexts";
import { useWebStoreContext } from "contexts";
import { usePopupsState } from "hooks/usePopupsState";
import { usePostMetadataMutation } from "redux/apis";

const FriendShop = () => {
	const { open } = usePopUpsV2();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { userTracker, syncUserTracker } = useWebStoreContext();
	const { isAnyPopupOpen, hasSeenRequiredPageTutorial } = usePopupsState();
	const [hasSeenFriendShopFtue, setHasSeenFriendShopFtue] =
		useState<boolean>(false);
	const [
		postMetadata,
		{ isLoading: isSavingFriendShopFtue, isSuccess: hasSavedFriendShopFtue }
	] = usePostMetadataMutation({ fixedCacheKey: "friend-shop-ftue-metadata" });

	const handleInfoClick = () => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "friend_shop_tutorial",
			event_type: "friend_shop",
			action: "tutorial_clicked",
			source: "friend_shop"
		});

		open({
			variant: "friend-shop-info-popup",
			id: "friend-shop-info-popup",
			replaceIfExists: true
		});
	};

	// *Trigger FTUE popup on first visit
	useEffect(() => {
		if (
			!userTracker?.metadata?.hasDisplayedFriendShopFtue &&
			hasSeenRequiredPageTutorial &&
			!hasSavedFriendShopFtue &&
			!isSavingFriendShopFtue &&
			!hasSeenFriendShopFtue &&
			!isAnyPopupOpen
		) {
			handleInfoClick();
			setHasSeenFriendShopFtue(true);
			postMetadata({
				key: "hasDisplayedFriendShopFtue",
				value: "true"
			}).unwrap();
			syncUserTracker();
		}
	}, [
		userTracker?.metadata?.hasDisplayedFriendShopFtue,
		hasSeenRequiredPageTutorial,
		hasSavedFriendShopFtue,
		isSavingFriendShopFtue,
		hasSeenFriendShopFtue,
		isAnyPopupOpen
	]);

	const refetchOptions = {
		refetchOnMountOrArgChange: true,
		refetchOnFocus: true,
		refetchOnReconnect: true
	};

	// Fetching gifts data to ensure it's available in the cache for child components
	const { data: giftsData } = useGetGiftsFriendShopQuery(
		undefined,
		refetchOptions
	);

	return (
		<Container>
			<Title>FRIEND SHOP</Title>
			<InfoButton aria-label="open info popup" onClick={handleInfoClick}>
				<InfoIcon width={35} height={35} />
			</InfoButton>
			<Outlet />
		</Container>
	);
};

export default FriendShop;
